import React from 'react';
import { TextField } from '@mui/material';

export default ({
  value = '', onChange = (e) => e, label = '', error = '', helpText, element, ...props
}) => (
  <>
    <TextField
      label={label}
      margin="normal"
      variant="outlined"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={!!error}
      helperText={error || helpText}
      {...props}
    />
    {
      element
    }
  </>
);
